import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { RequestResponsePattern, RequestStatusPattern } from "../../../../types/Request"
import { LinksTutoriaisConfigType, LinksTutoriaisListaType } from "../types"

interface State {
    requestGet: RequestStatusPattern<RequestResponsePattern<any[]>>
    requestSave: RequestStatusPattern<RequestResponsePattern<any>>
    requestRemove: RequestStatusPattern<RequestResponsePattern<any>>
    requestConfig: RequestStatusPattern<RequestResponsePattern<LinksTutoriaisConfigType>>

    lista: LinksTutoriaisListaType[] | null
    listaFiltered: LinksTutoriaisListaType[] | null
    config: LinksTutoriaisConfigType | null
    currentLista: LinksTutoriaisListaType | null
    currentItem: any | null
    fieldFiltered: string
}

const initialState: State = {
    requestGet: { data: null, loading: false, error: false, message: null },
    requestSave: { data: null, loading: false, error: false, message: null },
    requestRemove: { data: null, loading: false, error: false, message: null },
    requestConfig: { data: null, loading: false, error: false, message: null },
    lista: null,
    listaFiltered: null,
    config: null,
    currentLista: null,
    currentItem: null,
    fieldFiltered: '',
}

const LinksTutoriaisSlice = createSlice({
    name: 'LinksTutoriais',
    initialState,
    reducers: {
        setRequestGetData: (state, action: PayloadAction<RequestResponsePattern<any[]>>) => {
            state.requestGet.data = action.payload
            state.requestGet.loading = false
            state.requestGet.error = false
        },
        setRequestGetLoading: (state) => {
            state.requestGet.loading = true
            state.requestGet.error = false
        },
        setRequestGetError: (state) => {
            state.requestGet.loading = false
            state.requestGet.error = true
        },
        setRequestGetMessage: (state, action: PayloadAction<string>) => {
            state.requestGet.message = action.payload
        },
        setRequestSaveData: (state, action: PayloadAction<RequestResponsePattern<any>>) => {
            state.requestSave.data = action.payload
            state.requestSave.loading = false
            state.requestSave.error = false
        },
        setRequestSaveLoading: (state) => {
            state.requestSave.loading = true
            state.requestSave.error = false
        },
        setRequestSaveError: (state) => {
            state.requestSave.loading = false
            state.requestSave.error = true
        },
        setRequestConfigData: (state, action: PayloadAction<RequestResponsePattern<LinksTutoriaisConfigType>>) => {
            state.requestConfig.data = action.payload
            state.requestConfig.loading = false
            state.config = action.payload.listaResultados
        },
        setRequestConfigLoading: (state) => {
            state.requestConfig.loading = true
        },
        setRequestConfigError: (state) => {
            state.requestConfig.loading = false
            state.requestConfig.error = true
        },
        setRequestRemoveData: (state, action: PayloadAction<RequestResponsePattern<any>>) => {
            state.requestRemove.data = action.payload
            state.requestRemove.loading = false
        },
        setRequestRemoveLoading: (state) => {
            state.requestRemove.loading = true
        },
        setLista: (state, action: PayloadAction<LinksTutoriaisListaType[]>) => {
            state.lista = action.payload
        },
        setListaFiltered: (state, action: PayloadAction<LinksTutoriaisListaType[] | null>) => {
            state.listaFiltered = action.payload
        },
        setConfig: (state, action: PayloadAction<LinksTutoriaisConfigType>) => {
            state.config = action.payload
        },
        setCurrentLista: (state, action: PayloadAction<LinksTutoriaisListaType | null>) => {
            state.currentLista = action.payload
        },
        setCurrentItem: (state, action: PayloadAction<any | null>) => {
            state.currentItem = action.payload
        },
        setFieldFiltered: (state, action: PayloadAction<string>) => {
            state.fieldFiltered = action.payload
        },
    }
})

export const {
    setRequestGetData, setRequestGetLoading, setRequestGetError, setRequestGetMessage,
    setRequestSaveData, setRequestSaveLoading, setRequestSaveError,
    setRequestRemoveData, setRequestRemoveLoading,
    setRequestConfigData, setRequestConfigLoading, setRequestConfigError,
    setLista, setListaFiltered, setConfig, setCurrentLista, setCurrentItem, setFieldFiltered
} = LinksTutoriaisSlice.actions

export default LinksTutoriaisSlice.reducer
